module.exports = __webpack_public_path__ + "static/usecase_phone2@3x-2d51518892d930fc767ec6171dd599a8.png";